var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "inline" } },
    [
      _c("i", {
        staticClass: "fas fa-info-circle cursor-pointer",
        on: {
          click: function($event) {
            return _vm.afficherMouvements()
          }
        }
      }),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal" + _vm.id,
            size: "xxl",
            title: _vm.titre(),
            "ok-title": "Fermer",
            "ok-only": "",
            "no-close-on-backdrop": ""
          },
          on: {
            ok: function($event) {
              return _vm.hide()
            }
          }
        },
        [
          _c("template", { slot: "default" }, [
            _vm.lot
              ? _c(
                  "div",
                  [
                    _c("MvtsStockListe", {
                      attrs: {
                        lot: _vm.lot,
                        debut: _vm.debut,
                        fin: _vm.fin,
                        quantiteInitiale: _vm.quantiteInitiale,
                        avecDetails: _vm.avecDetails
                      }
                    })
                  ],
                  1
                )
              : _vm.ingredient
              ? _c(
                  "div",
                  _vm._l(_vm.ingredient.lots, function(lot, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c(
                          "div",
                          { staticStyle: { margin: "15px 0 0 15px" } },
                          [
                            _c(
                              "span",
                              { staticStyle: { display: "inline-block" } },
                              [_vm._v("N° Lot : " + _vm._s(lot.NumLot))]
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  "margin-left": "50px"
                                }
                              },
                              [
                                _vm._v(
                                  "Désignation : " +
                                    _vm._s(lot.designationFournisseur)
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  "margin-left": "50px"
                                },
                                attrs: {
                                  title:
                                    "Date de Durabilité Minimale (ex. DLUO)"
                                }
                              },
                              [
                                _vm._v(
                                  "DLC / DDM : " +
                                    _vm._s(_vm.formatHumanDate(lot.dlcDluo))
                                )
                              ]
                            )
                          ]
                        ),
                        _c("MvtsStockListe", {
                          attrs: {
                            lot: lot,
                            debut: _vm.debut,
                            fin: _vm.fin,
                            quantiteInitiale: _vm.quantiteInitiale,
                            avecDetails: _vm.avecDetails
                          }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e()
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }